<template>
  <div>
    <button class="mdc-fab mdc-fab--mini mdc-fab--touch" @click="onClick()">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    onClick: Function,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/variables';

button {
  background-color: $light-blue;
  border: 1px solid $blue;
  box-shadow: none !important;
  min-width: 4px;
  min-height: 4px;
  max-width: 26px;
  max-height: 26px;
  font-size: 16px;
  margin: 0 0.25rem;

  i {
    color: $blue;
    font-size: 14px;
    position: relative;
    bottom: 1px;
  }
}
</style>
